import React from 'react'

function Events() {
    return (
        <div>
            <h1>Event Page</h1>
        </div>
    )
}

export default Events
